import React, { Component } from "react"
import Grid from "@material-ui/core/Grid"
import { withStyles } from "@material-ui/core"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Cookies } from "react-cookie"
import Snackbar from "@material-ui/core/Snackbar"

import { Redirect } from "react-router-dom"
import * as constants from "../constants"
import "react-modern-calendar-datepicker/lib/DatePicker.css"
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";


const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangePaymentGateway extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  optionBankStatus : [],
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",

            }
      }

      updateBankStatus(i){
            var self = this

            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              return true;
                        }
                        else if (arr.result === "error") {
                              self.setState({snackstr: arr.desc, showSnack: true, snackMode: "error"})
                              return false;
                        }
                        console.log("second")
                  }
            }
            var fd = new FormData()
            fd.append("command", "update_bank")
            fd.append("bank_id", this.state.optionBankStatus[i].bank_id)
            fd.append("bank_status", !(this.state.optionBankStatus[i].bank_status === "1"))

            xhttp.open("POST", `${constants.BASE_URL}/Bank`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)


      }
      handleChangeBankActivation = (i) =>{
            let t = this.state.optionBankStatus;
            // t[i].bank_status = !t[i].bank_status;
            this.updateBankStatus(i)
            t[i].bank_status = (t[i].bank_status === "1") ?"0" : "1";
            this.setState({optionBankStatus : t})


      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }
      getBankStatusOption = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ optionBankStatus: arr.data }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }

                  }
            }
            var fd = new FormData()
            fd.append("command", "get_bank")

            xhttp.open("POST", `${constants.BASE_URL}/Bank`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }


      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  console.log("propssss",this.props.props.dispatch)
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    /*
                                          SHOULD BE RELACED
                                     */
                                    self.getBankStatusOption();

                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      render() {
            const { classes } = this.props
            const {
                  redirect,
                  optionBankStatus,
                  showSnack,
                  snackMode,
                  snackstr,


            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                  <div>
                        <Snackbar
                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                            onClose={this.handleClickcloseTasckBar}
                            open={showSnack}
                            autoHideDuration={10000}
                        >
                              <Alert severity={snackMode}>{snackstr}</Alert>
                        </Snackbar>
                            <p style={{padding: "10px", display:"block"}}>وضعیت درگاه های بانکی</p>
                            <br />

                                  {optionBankStatus.map((bank, i) => {
                                        return (
                                                <>

                                                  <FormControlLabel
                                                            control={
                                                                  <Switch
                                                                      checked={bank.bank_status === "1"}
                                                                      onChange={(e)=>this.handleChangeBankActivation(i)}
                                                                      name="gilad"
                                                                  />
                                                            }
                                                            label={bank.bank_name}
                                                  />
                                                      <br/>
                                                </>
                                        )
                                  })
                            }

                  </div>

                  )
            }
      }
}

export default withStyles(styles)(ChangePaymentGateway)
